import React from 'react';

const TermsAndConditions = () => {
  return (
    <div className="md:px-24 mx-auto px-4 text-black font-sans md:mb-20 mb-10">
      <h2 className="md:text-[36px] text-[14px] font-bold text-[#03897B] mb-4">TERMS AND CONDITIONS</h2>
      <p className="md:text-[24px] text-[10px] font-light mb-6">Website Terms and Conditions of Use</p>
      <p className="md:text-[24px] text-[10px] font-light text-black mb-8">Updated: 30th April 2025</p>

      <div className="md:space-y-8 space-y-5 font-light text-[10px] leading-relaxed md:text-[24px]">
        <section>
          <h3 className="md:-mb-2 mb-1">1. Introduction</h3>
          <p>
            Welcome to Ad-Luck website. This website is operated by Ad-Luck Holdings, a business registered in South Africa. By accessing or using our Website, you agree to be bound by these Terms and Conditions ("Terms"). If you do not agree, please refrain from using the Website.
          </p>
        </section>

        <section>
          <h3 className="md:-mb-2 mb-1">2. Applicable Legislation</h3>
          <p>These Terms are governed by the laws of the Republic of South Africa, including but not limited to:</p>
          <ul className="list-disc list-inside mt-2 space-y-1">
            <li>The Electronic Communications and Transactions Act (ECTA)</li>
            <li>The Protection of Personal Information Act (POPIA)</li>
            <li>The Consumer Protection Act (CPA)</li>
          </ul>
        </section>

        <section>
          <h3 className="md:-mb-2 mb-1">3. Use of the Website</h3>
          <p>You agree to use this Website in accordance with South African law and for lawful purposes only. You may not:</p>
          <ul className="list-disc list-inside mt-2 space-y-1">
            <li>Upload or distribute unlawful, defamatory, or offensive content</li>
            <li>Attempt to gain unauthorised access to our systems</li>
            <li>Disrupt the operation or security of the Website</li>
          </ul>
        </section>

        <section>
          <h3 className="md:-mb-2 mb-1">4. Intellectual Property</h3>
          <p>
            All content on the Website — including text, images, graphics, logos, and software — is the property of [Your Company Name] or licensed to us, and protected by local and international copyright laws. You may not reproduce or use content for commercial purposes without permission.
          </p>
        </section>

        <section>
          <h3 className="md:-mb-2 mb-1">5. Privacy Policy</h3>
          <p>
            Your privacy is important to us. By using this Website, you consent to the collection and use of personal information as outlined in our [Privacy Policy], in compliance with POPIA.<br />
            We will not sell or share your personal information without your consent, except where required by law.
          </p>
        </section>

        <section>
          <h3 className="md:-mb-2 mb-1">6. Limitation of Liability</h3>
          <p>
            This Website is provided “as is.” Ad-Luck Holdings makes no warranties, either express or implied, regarding the Website’s performance or availability.<br />
            We will not be liable for any direct or indirect loss, damage, or expense, whether arising in contract, delict (including negligence), or otherwise, arising from your use of the Website.
          </p>
        </section>

        <section>
          <h3 className="md:-mb-2 mb-1">7. Consumer Protection Rights</h3>
          <p>
            If you are a consumer for purposes of the Consumer Protection Act, no provision in these Terms is intended to limit your rights under the CPA. If there is a conflict between these Terms and the CPA, the CPA shall prevail.
          </p>
        </section>

        <section>
          <h3 className="md:-mb-2 mb-1">8. Third-Party Links</h3>
          <p>
            Our Website may include links to third-party websites. We are not responsible for the content, availability, or practices of such websites, and their inclusion does not imply endorsement.
          </p>
        </section>

        <section>
          <h3 className="md:-mb-2 mb-1">9. Changes to Terms</h3>
          <p>
            We reserve the right to modify these Terms at any time. Any changes will be effective immediately upon posting to the Website. Your continued use of the Website will constitute your acceptance of the updated Terms.
          </p>
        </section>

        <section>
          <h3 className="md:-mb-2 mb-1">10. Governing Law</h3>
          <p>
            These Terms and your use of the Website shall be governed by and construed in accordance with the laws of the Republic of South Africa.
          </p>
        </section>

        <section>
          <h3 className="md:-mb-2 mb-1">11. Contact Information</h3>
          <p>
            If you have any questions regarding these Terms, please contact us at:<br />
            📧 Email: Info@adluck.co.za<br />
            📍 Address: Midstream, Centurion Gauteng South Africa
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsAndConditions;
